import { useBranding } from "@root/hooks/useBranding";
import React, { createContext, useContext, ReactNode } from "react";

export const BrandingContext = createContext<IBrandingContextValue | undefined>(
  undefined
);

interface BrandingContextProviderProps {
  children: ReactNode;
}

export const BrandingContextProvider: React.FC<
  BrandingContextProviderProps
> = ({ children }) => {
  const data = useBranding();
  return (
    <BrandingContext.Provider value={data}>{children}</BrandingContext.Provider>
  );
};

export const useBrandingContext = (): IBrandingContextValue => {
  const context = useContext(BrandingContext);
  if (!context) {
    throw new Error(
      "useBrandingContext must be used within BrandingContextProvider"
    );
  }
  return context;
};
